import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    // data: [],
};

const transactionReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.TRANSACTION_LIST]: (state, action) => ({
        ...state,
        rs: action.value
    }),
    [type.TRANSACTION_CANCEL]: (state, action) => ({
        ...state,
        cancel: action.value
    }),
    [type.TRANSACTION_DROPDOWN]: (state, action) => ({
        ...state,
        dropdown: action.value
    })
});

export default transactionReducer;